import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { MovientacaoSocietariaRoutingModule } from './movimentacao-societaria-routing.module';
import { MovimentacaoSocietariaListComponent } from './pages/movimentacao-societaria-list/movimentacao-societaria-list.component';
import { MovimentacaoSocietariaNaturezaMudancaComponent } from './pages/movimentacao-societaria-natureza-mudanca/movimentacao-societaria-natureza-mudanca.component';
import { MovimentacaoSocietariaMudancaSocietariaComponent } from './pages/movimentacao-societaria-mudanca-societaria/movimentacao-societaria-mudanca-societaria.component';
import { MovimentacaoSocietariaExportarModalComponent } from './components/movimentacao-societaria-exportar-modal/movimentacao-societaria-exportar-modal.component';
import { MovimentacaoSocietariaHistoricoExportModalComponent } from './components/movimentacao-societaria-historico-export-modal/movimentacao-societaria-historico-export-modal.component';
import { MovimentacaoSocietariaMudarStatusModalComponent } from './components/movimentacao-societaria-mudar-status-modal/movimentacao-societaria-mudar-status-modal.component';
import { EntidadeEnvolvidaFormComponent } from './components/entidade-envolvida-form/entidade-envolvida-form.component';
import { EntidadeEnvolvidaModalComponent } from './components/entidade-envolvida-modal/entidade-envolvida-modal.component';
import { DocumentoModule } from '@modules/documento/documento.module';
import { MovimentacaoSocietariaTabelaComponent } from './components/movimentacao-societaria-tabela/movimentacao-societaria-tabela.component';
import { DocumentoMovimentacaoSocietariaFormComponent } from './components/documento-movimentacao-societaria-form/documento-movimentacao-societaria-form.component';
import { DocumentoMovimentacaoSocietariaListComponent } from './components/documento-movimentacao-societaria-list/documento-movimentacao-societaria-list.component';

@NgModule({
  declarations: [
    MovimentacaoSocietariaListComponent,
    MovimentacaoSocietariaNaturezaMudancaComponent,
    MovimentacaoSocietariaMudancaSocietariaComponent,
    MovimentacaoSocietariaExportarModalComponent,
    MovimentacaoSocietariaHistoricoExportModalComponent,
    MovimentacaoSocietariaMudarStatusModalComponent,
    EntidadeEnvolvidaFormComponent,
    EntidadeEnvolvidaModalComponent,
    MovimentacaoSocietariaTabelaComponent,
    DocumentoMovimentacaoSocietariaFormComponent,
    DocumentoMovimentacaoSocietariaListComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    SharedModule,
    MovientacaoSocietariaRoutingModule,
    SharedModule,
    NgxPermissionsModule.forChild(),
    NgxMaskDirective,
    NgxMaskPipe,
    DocumentoModule
  ],
  exports:[
    MovimentacaoSocietariaTabelaComponent
  ],
  providers:[

  ]
})
export class MovimentacaoSocietariaModule { }
